export interface LinkColumnItem {
  label: string;
  routerLink: string | null;
}

export function isLinkColumnItem(item: unknown): item is LinkColumnItem {
  return typeof item === 'object' && item !== null && item.hasOwnProperty('label') && item.hasOwnProperty('routerLink');
}
